import { combineReducers } from 'redux';

import AssetReducer from './AssetReducer';
import InteractiveReducer from './InteractiveReducer';
import DirtyReducer from './DirtyReducer';
import UserReducer from './UserReducer';
import ErrorReducer from './ErrorReducer';

const rootReducer = combineReducers({
  interactive: InteractiveReducer,
  assets: AssetReducer,
  dirty: DirtyReducer,
  errors: ErrorReducer,
  user: UserReducer,
});

export default rootReducer;
